import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data4 from "../../Data/emergencyNumbers/emergencyNumbers.json";

export default function EmergencyNumbers() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Телефоны справочных служб
      </h1>

      {/* <h3 className="about-nii__title antiCorruption__title"></h3> */}
      <Accordion data={data4} />
    </section>
  );
}
